const PASSWORD_REQUIREMENTS = [
  {
    id: 'length',
    test: (value = '') => value.length >= 8,
    message: 'Password must be at least 8 characters long.',
    label: 'At least 8 characters in length'
  },
  {
    id: 'uppercase',
    test: (value = '') => /[A-Z]/.test(value),
    message: 'Password must contain at least one uppercase letter.',
    label: 'Contains at least one uppercase letter'
  },
  {
    id: 'lowercase',
    test: (value = '') => /[a-z]/.test(value),
    message: 'Password must contain at least one lowercase letter.',
    label: 'Contains at least one lowercase letter'
  },
  {
    id: 'number',
    test: (value = '') => /\d/.test(value),
    message: 'Password must contain at least one number.',
    label: 'Contains at least one number'
  },
  {
    id: 'special',
    test: (value = '') => /[^A-Za-z0-9]/.test(value),
    message: 'Password must contain at least one special character.',
    label: 'Contains at least one special character'
  }
]

export const getPasswordRequirementStates = (value = '') => {
  return PASSWORD_REQUIREMENTS.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(value)
  }))
}

export const validatePassword = (value = '') => {
  const unmetRule = PASSWORD_REQUIREMENTS.find((rule) => !rule.test(value))
  return {
    isValid: !unmetRule,
    unmetRule,
    errorMessage: unmetRule ? unmetRule.message : ''
  }
}

export const PASSWORD_POLICY_DESCRIPTION =
  'Passwords must be at least 8 characters long and include upper and lower case letters, a number, and a special character.'

export default PASSWORD_REQUIREMENTS
